export default __webpack_public_path__ + "static/assets/42ed010d53b81aec0679622a731ea799.gif";